import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum-slim';

import config from './config';

const applicationId = config.datadog.applicationId || '';
const clientToken = config.datadog.clientToken || '';
const { environment } = config.launchdarkly;
const site = config.datadog.site || ('datadoghq.com' as const);

const baseConfig = {
  clientToken,
  site: site as 'datadoghq.com',
  service: 'vitalstatistix',
  env: environment,
  version: process.env.REVISION,
  sampleRate: 100,
};

export const initDatadogRUM = () => {
  if (applicationId && clientToken) {
    datadogRum.init({
      clientToken: baseConfig.clientToken,
      applicationId,
      site: baseConfig.site,
      service: baseConfig.service,
      env: baseConfig.env,
      version: baseConfig.version,
      sessionReplaySampleRate: 0,
      sessionSampleRate: baseConfig.sampleRate,
    });
  }

  if (clientToken) {
    datadogLogs.init({
      clientToken: baseConfig.clientToken,
      site: baseConfig.site,
      service: baseConfig.service,
      env: baseConfig.env,
      version: baseConfig.version,
      forwardErrorsToLogs: true,
    });
  }
};
